var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvertime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "more_time_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2148",
    "data-name": "Group 2148"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3377",
    "data-name": "Rectangle 3377",
    width: 16,
    height: 16,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3378",
    "data-name": "Rectangle 3378",
    width: 16,
    height: 16,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2150",
    "data-name": "Group 2150",
    transform: "translate(1.32 1.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2149",
    "data-name": "Group 2149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8369",
    "data-name": "Path 8369",
    d: "M10.5,8a.5.5,0,0,0-.5.5v3.1a.659.659,0,0,0,.31.561l2.4,1.479a.471.471,0,1,0,.488-.805L10.99,11.5v-3A.5.5,0,0,0,10.5,8Z",
    transform: "translate(-4.719 -4.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8370",
    "data-name": "Path 8370",
    d: "M12.508,9.281a4.379,4.379,0,0,1,.053.66,4.616,4.616,0,1,1-3.3-4.429V4.152A5.782,5.782,0,0,0,7.941,4a5.941,5.941,0,1,0,5.941,5.941,5.453,5.453,0,0,0-.04-.66Z",
    transform: "translate(-2 -2.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8371",
    "data-name": "Path 8371",
    d: "M19.621,3.98H18.3V2.66a.66.66,0,0,0-1.32,0V3.98H15.66a.66.66,0,1,0,0,1.32h1.32v1.32a.66.66,0,0,0,1.32,0V5.3h1.32a.66.66,0,0,0,0-1.32Z",
    transform: "translate(-6.419 -2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvertime);
export default __webpack_public_path__ + "static/media/overtime.7d84950fab3ad9ac7672348f9f5602d8.svg";
export { ForwardRef as ReactComponent };